import React, { useEffect, useState, useRef } from 'react';
import {useNavigate} from "react-router";
import { motion } from "framer-motion";
import { Base64 } from 'js-base64';
import { useDispatch, useSelector} from 'react-redux';
import { closeSearch } from '../../components/NavTopBar/actions';
import FilterComponent from '../../components/FilterComponent/FilterComponent';
import "./styles.css";
import {isSearchVisible} from "../../components/NavTopBar/reducer";
import {getAuthToken} from "../../components/UserLogin/reducer";
import CounterpartiesTableComponent from "../../components/CounterpartiesTableComponent";
import {AnimatePresence} from "motion/react";
import {getLanguage} from "../../components/LanguageModal/reducer";
import translations from "../../components/LanguageModal/translations";
import {useNotification} from "../../components/Notification";
import {getCountries, isCountriesFetching} from '../../components/AddressCard/reducer';
import {fetchCounters, COUNTERS_PAGE_COUNT} from "./actions";
import {getCounters, getCountersFetching, getCountersHasMore} from "./reducer";
import {Dimmer, Dropdown, Loader} from "semantic-ui-react";
import {getRolesAccess} from "../../components/Roles/Roles";
import {fetchCounties} from "../../components/AddressCard/actions";

const Counterparties = () => {
    const token = useSelector((state) => getAuthToken(state.userLogin));
    const navigate = useNavigate();
    const dispatch = useDispatch();

    if (!token) {
        return (
            <strong style={{margin: '0 0 0 50px'}}>Для получения доступа к списку, пожалуйста, авторизуйтесь</strong>
        )
    }

    const counters = useSelector((state) => getCounters(state.counters));
    const hasMore = useSelector((state) => getCountersHasMore(state.counters));
    const loading = useSelector((state) => getCountersFetching(state.counters));
    const countries = useSelector((state) => getCountries(state.address));
    const { openNotification, contextHolder } = useNotification();
    const notificationShown = useRef(false);

    const [filterData, setFilterData] = useState({
        countries: [],
        segments: [],
        industries: [],
        search: '',
        crm_status: [],
        event: []
    })
    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];
    const t = (key) => {
        const languageString = language[0]+language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };
    const arrayCountries = countries && countries.countries ? Object.values(countries.countries).map(country => ({
        'key': country.iso.toLowerCase(),
        'value': country.iso.toLowerCase(),
        'flag': country.iso.toLowerCase(),
        'text': languageString === "en" ? country.country_en : country.country_ru,
        'states': country.states
    })) : [];

    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const eventsList = useSelector((state) => state.userLogin.userData.options.events);
    const eventsOptions = [...eventsList.active, ...eventsList.archive].map(event => ({
        text: event,
        value: event,
    }));
    const segmentsList= useSelector((state) => state.userLogin.userData.options.segments);
    const segmentsOptions = Object.keys(segmentsList).map(key => ({ text: segmentsList[key], value: key }));
    const industriesList = useSelector((state) => state.userLogin.userData.options?.industries || []);
    const industriesOptions = Object.keys(industriesList).map(key => ({ text: industriesList[key], value: key }));

    const crmStatusOptions = [
        {
            value: 'client',
            text: languageString==='ru' ? 'Действующий клиент' : 'Сlient',
        },
        {
            value: 'hot lead',
            text: languageString==='ru' ? 'Потенциальный клиент' : 'Hot lead',
        },
        {
            value: 'cold lead',
            text: languageString==='ru' ? 'Холодный лид' : 'Cold lead'
        },
        {
            value: 'lost client',
            text: languageString==='ru' ? 'Ушедший клиент' : 'Lost client',
        }
    ]

    const userData = useSelector((state) => state.userLogin.userData);
    const roleAccess = getRolesAccess(userData.roles);
    useEffect(() => {
        window.scrollTo(0, 0);
        if(!roleAccess.pageCounter || !token) {
            navigate('/')
        }
        if (token) {
            readCounters(1, filterData)
            dispatch(fetchCounties());
        }
    }, []);

    useEffect(() => {
        if (!notificationShown.current) {
            const timer = setTimeout(() => {
                openNotification('topRight');
                notificationShown.current = true;
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [openNotification]);

    const readCounters = (page, fparams) => {
        dispatch(fetchCounters(token, {
            lang: languageString,
            page: page ? page : '',
            per_page: COUNTERS_PAGE_COUNT,
            order: 'desc',
            order_by: 'id',
            countries: fparams.countries,
            segments: fparams.segments,
            search: fparams.search,
            crm_status: fparams.crm_status,
            event: fparams.event,
            industries: fparams.industries,
        }, t));
    };

    const loadCounters = () => {
        if (hasMore) {
            const nextPage = Math.round(counters.length / COUNTERS_PAGE_COUNT) + 1;
            readCounters(nextPage, filterData);
        }
    };

    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
    const requestSort = key => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };

    const handleChangeSearch = (e) => {
        const value = e.target.value;
        setFilterData({ ...filterData, search: value});
        if (value.length > 3) readCounters(1, { ...filterData, search: value});
        if (value.length === 0) readCounters(1, { ...filterData, search: value});
    };

    const handleChangeEvent = (e, {value}) => {
        setFilterData({ ...filterData, event: value });
        readCounters(1, {
            ...filterData,
            event: value,
        });
    }

    const handleChangeIndustries = (e, {value}) => {
        setFilterData({ ...filterData, industries: value });
        readCounters(1, {
            ...filterData,
            industries: value
        })
    }

    const handleChangeCountry = (e, {value}) => {
        setFilterData({
            ...filterData,
            countries: value,
        })
        readCounters(1, {
            ...filterData,
            countries: value,
        });
    }
    const handleChangeSegments = (e, {value}) => {
        setFilterData({
            ...filterData,
            segments: value,
        })
        readCounters(1, {
            ...filterData,
            segments: value,
        });
    }
    const handleChangeStatus = (e, {value}) => {
        setFilterData({
            ...filterData,
            crm_status: value,
        })
        readCounters(1, {
            ...filterData,
            crm_status: value,
        });
    }

    return (
        <div className='counter'
             onClick={() => {
                 requestSort('reset')
             }}
        >
            <div className="counter-title" >{t('agents')}</div>
            <div className="counter-btn-ctn">
                <button className="counter-btn btn-red" onClick={() => navigate('../counterparties-form')}>{t('createBtn')}</button>
                <FilterComponent  open={isFilterOpen} onChange={() => setIsFilterOpen(!isFilterOpen)} />
            </div>
            <AnimatePresence initial={false}>
                {isFilterOpen ? <motion.div
                    className='counter-filter-content'
                    initial={{maxHeight: 0, opacity: 0}}
                    animate={{maxHeight: 1000, opacity: 1, transition: {duration: 1}}}
                    exit={{maxHeight: 0, opacity: 0, transition: {duration: 0.4}}}
                >
                    <div className='counter-column'>
                        <div className='counter-filter-ctn'>
                            <label className='counter-label'>{t('search')}</label>
                            <input
                                type="text"
                                value={filterData.search}
                                onChange={handleChangeSearch}
                                className='cform-input'
                                style={{height: '40px', padding: '5px 5px'}}
                                placeholder={t('searchPlaceholder')}
                            />
                        </div>
                        <div className='counter-flex'>
                            <div className='counter-filter-ctn'>
                                <label className='counter-label'>{t('areaActivity')}</label>
                                <Dropdown
                                    fluid
                                    search
                                    scrolling
                                    style={{maxWidth: '300px'}}
                                    selection
                                    multiple
                                    options={industriesOptions}
                                    className='cform-drop filter-drop'
                                    value={filterData.industries}
                                    onChange={handleChangeIndustries}
                                />
                            </div>
                            <div className='counter-filter-ctn'>
                                <label className='counter-label'>{t('segments')}</label>
                                <Dropdown
                                    fluid
                                    search
                                    scrolling
                                    selection
                                    multiple
                                    options={segmentsOptions}
                                    className='cform-drop filter-drop'
                                    value={filterData.segments}
                                    onChange={handleChangeSegments}
                                />
                            </div>
                            <div className='counter-filter-ctn'>
                                <label className='counter-label'>{t('country')}</label>
                                <Dropdown
                                    fluid
                                    search
                                    scrolling
                                    selection
                                    multiple
                                    options={arrayCountries}
                                    className='cform-drop filter-drop'
                                    value={filterData.country}
                                    onChange={handleChangeCountry}
                                />
                            </div>
                        </div>
                        <div className='counter-flex'>
                            <div className='counter-filter-ctn'>
                                <label className='counter-label'>{t('exhibition')}</label>
                                <Dropdown
                                    fluid
                                    search
                                    scrolling
                                    style={{maxWidth: '300px'}}
                                    selection
                                    multiple
                                    options={eventsOptions}
                                    className='cform-drop filter-drop'
                                    value={filterData.event}
                                    onChange={handleChangeEvent}
                                />
                            </div>
                            <div className='counter-filter-ctn'>
                                <label className='counter-label'>{t('counterStatus')}</label>
                                <Dropdown
                                    fluid
                                    search
                                    scrolling
                                    style={{maxWidth: '300px'}}
                                    selection
                                    multiple
                                    options={crmStatusOptions}
                                    className='cform-drop filter-drop'
                                    value={filterData.crm_status}
                                    onChange={handleChangeStatus}
                                />
                            </div>
                        </div>
                    </div>
                </motion.div> : null}
            </AnimatePresence>

            <CounterpartiesTableComponent
                counters={counters}
                languageString={languageString}
                loadCounters={loadCounters}
                hasMore={hasMore}
                t={t}
                isLoading={loading}
                sortConfig={sortConfig}
                requestSort={requestSort}
            />

            <Dimmer
                active={loading}
                inverted
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}
            >
                <Loader size="large">{t('loadingCounters')}</Loader>
            </Dimmer>
        </div>
    );
};

export default Counterparties;